import { render, staticRenderFns } from "./descriptionInputCounter.vue?vue&type=template&id=6c41c32e&"
import script from "./descriptionInputCounter.vue?vue&type=script&lang=ts&"
export * from "./descriptionInputCounter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports